// Copyright (C) 2020-2023 Berkadia Commercial Mortgage, LLC - All Rights Reserved
import React, { useState, createContext } from 'react'
import HomePageNav from '../../GlobalNavbar/GlobalNavbar'
import CreateNewEmailList from './CreateNewEmailList'
import CreateNewEmailListCSV from './CreateNewEmailListCSV'
import '../css/AddedStyles.css'
import '../../../../src/Styles/habitat-global.css'
import ListsDetails from './ListsDetails'
import Snackbar from '@material-ui/core/Snackbar';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export const DashboardContext = createContext()

const EmailListsDashboard = () => {

    const [searchText, setSearchText] = React.useState('')
    const [createListType, setCreateListType] = useState(null)
    const [snackBar, setSnackBar] = useState({
        show: false,
        type: 'success',
        message: 'success asdad'
    })

    return (
        <DashboardContext.Provider value={{ setSnackBar }}>
            <div data-testid="ELD_landing_page_test" className="bg-gray-10">
                <HomePageNav setCreateListType={setCreateListType} searchText={searchText} handleSearchCriteria={setSearchText} />
                <CreateNewEmailList open={createListType === 0} setCreateListType={setCreateListType} />
                <CreateNewEmailListCSV open={createListType === 1} setCreateListType={setCreateListType} />
                <ListsDetails searchText={searchText} />
            </div>
            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                open={Boolean(snackBar.show)}
                // open={true}
                autoHideDuration={6000}
                onClose={()=>setSnackBar({show: false, type: null, message: null})}
            >
                <div className={`flex font-medium p-5 rounded ${snackBar.type === 'error' ? 'snackbar-error' : 'snackbar-success'}`}>
                    <div>{snackBar.type === 'error' ? <ErrorOutlineIcon/> : <CheckCircleIcon/>}</div>
                    <div>
                        <div className="ml-5 font-bold">{snackBar.type === 'error' ? 'Error Alert' : 'Success Alert'}</div>
                        <div className="ml-5">{snackBar.message}</div>
                    </div>
                </div>
            </Snackbar>
        </DashboardContext.Provider>
    )
}

export default EmailListsDashboard
